import React, { useState, useEffect, useRef } from 'react';

const CustomAudio = ({ recordingUrl }) => {
  const audioRef = useRef(null);
  const [audioState, setAudioState] = useState({
    play: false
  });

  useEffect(() => {
    function onEndedEvent() {
      setAudioState({
        play: false
      });
    }
    audioRef.current.addEventListener('ended', onEndedEvent);
    return () => {
      audioRef.current.removeEventListener('ended', onEndedEvent);
    };
  }, []);

  useEffect(() => {
    try {
      audioRef?.current?.load();
    } catch {}
  }, [recordingUrl]);

  return (
    <div>
      <audio
        controls
        ref={audioRef}
        style={{
          transform: 'scale(0.9)',
          width: '300px',
          height: '45px'
        }}
      >
        <source src={recordingUrl} type="audio/mp3" />
      </audio>
    </div>
  );
};

export default CustomAudio;
